import moment from 'moment';

//http://momentjs.com/docs/#/displaying/

function toDate(date) {
    return moment(date).format('DD/MM/YYYY');
}

export default { toDate };